import React from "react"

export default () => (
	<section className="section section-i">

		<div className="section-header">
			<h2>Not Found</h2>
		</div>

		<p>Vous venez de frapper un itinéraire qui n'existe pas...</p>
	</section>
)
